import { ca } from '@cian/analytics';

export function trackCollapseBlockShow(label: ECollapseBlockType) {
  ca('event', {
    name: 'oldevent',
    category: 'card',
    action: 'show_spoiler',
    label,
  });
}

export function trackCollapseBlockClose(label: ECollapseBlockType) {
  ca('event', {
    name: 'oldevent',
    category: 'card',
    action: 'close_spoiler',
    label,
  });
}

export enum ECollapseBlockType {
  FlatDescription = 'flat_description',
  Finishing = 'finishing',
  GeneralInfo = 'general_info',
  JkInfo = 'jk_info',
  Mortgage = 'mortgage',
  MoreFlats = 'more_flats',
}
